import type { FaireProductEntity } from "../../entity_types/product";

export const p_qf52nwdwd6: FaireProductEntity = {
  token: "p_qf52nwdwd6",
  type: "product",
  name: "Halloween/Thanksgiving/ Non-holiday Fall Item Mystery Box – 1 Item",
  brandToken: "b_xvvfvktx6s",
  brandName: "Rylee Faith Designs",
  imageUrl:
    "https://cdn.faire.com/fastly/314e350b6431861b128babfcfbf650838bd07de5d6638b6bee222830631beca2.png",
  galleryImageUrls: [],
  priceDollars: 5.49,
  description:
    "This is a Halloween / Thanksgiving / Non-holiday Fall Item Mystery Box – 1 Item.\n\nAll items are randomly selected from Halloween, Thanksgiving, or general fall seasonal styles.\n\nStyles are pre-packed and randomly chosen\nNo style selection or customization available\nItems are from fall-related collections only\nSome items may be tagless\nPlease purchase only if you are comfortable with receiving a random style\nIf you are not comfortable with not choosing the style, please do not place the order\n\nNo returns or exchanges accepted\n\nAvailable Sizes:\n\n3M，6M，12M，18M ， 2，3，4，5，6，7 ，7/8，8/9，9/10，10/12 \n\nSpecific styles, colors, and designs cannot be selected. Images are for reference only.\n",
  tags: [],
  msrpDollars: 10.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:53:37.474Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
